import { render, staticRenderFns } from "./WorkerGoal.html?vue&type=template&id=648a0a58&external"
import script from "./WorkerGoal.ts?vue&type=script&lang=ts&external"
export * from "./WorkerGoal.ts?vue&type=script&lang=ts&external"
import style0 from "./WorkerGoal.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports